import React, { useState, useEffect } from 'react';
import Chart from "react-apexcharts";
import useAxiosPrivate from "../hooks/useAxiosPrivate"




export const options = {
    title: "Sector % analysis",

    legend: { position: "none" },
    bar: { groupWidth: '70%', fontSize: "6px"},
    hAxis: {
        minValue: 0,
    }
};

function InvestorSectorChartMobile(props) {
    const [mapData, setMapData] = useState({})
    const axiosPrivate = useAxiosPrivate();

    

    const addMapData = () => {
        let tempMapData = []
        let label = []

        function sortDictByValue(dict) {
            return Object.keys(dict)
                .sort((a, b) => dict[b] - dict[a])
                .reduce((acc, key) => {
                    acc[key] = dict[key];
                    return acc;
                }, {});
        }
        const dict = props.sectorData
        const sortedDict = sortDictByValue(dict);

        if (props.source === "investor") {
            Object.keys(sortedDict).map(data => {
                tempMapData.push(parseFloat(props.sectorData[data]))
                label.push(data)
            })
        } else {
            Object.keys(sortedDict).map(data => {
                console.log(data)
                tempMapData.push(parseFloat(props.sectorData[data]["pct"]))
                label.push(props.sectorData[data]["sector"])
            })
        }
        setMapData({
            options: {
                chart: { id: "Investor Info" },
                colors: ['#455EB5', '#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
                dataLabels: { enabled: false},
                xaxis: {
                    categories: label,
                },
                yaxis: [{
                    forceNiceScale: true,
                    labels: {

                        style: {
                            fontSize: '6px',
                        },
                    }}],
                chart: {
                    type: 'bar'
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                    }
                },

            },
            series: [{ name: "Sector", data: tempMapData }]
        })
    }
    useEffect(() => {
        addMapData()
        
    }, [])

    return (
        <div className="SectorChart" style={{ paddingTop: "20px" }}>
            <h2 style={{ textAlign: "left" }}>{props.source === "investor" ? "Sector Analysis" : "Sector by ownership count"}</h2>
            <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
                {console.log(mapData)}
            {Object.keys(mapData)?.length > 0 && 
                <Chart
                    options={mapData.options}
                    series={mapData.series}
                    type="bar"
                    />
                }</div>
        </div>
    )

}


export default InvestorSectorChartMobile;